import { extend, localize, setInteractionMode } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'
import en from 'vee-validate/dist/locale/en.json'
import i18n from '@/lang'
import { API } from '@/plugins/api'
import { StringUtils } from '@/plugins/string'

localize({ en, ja })
localize(navigator.language.split('-')[0])
// 検証タイミングを変更
// https://logaretm.github.io/vee-validate/guide/interaction-and-ux.html#interaction-modes
setInteractionMode('eager')

// 全ルールのインポート
Object.keys(rules).forEach(function (rule) {
  return extend(rule, rules[rule])
})

// 標準必須チェックのメッセージ上書き
extend('required', {
  message: (fieldName) => {
    let message = ''
    if (fieldName == '{field}') {
      // チェック項目のlabelが空文字の場合
      message = i18n.t('MSG0072')
    } else {
      message = i18n.t('MSG0019', { p0: fieldName })
    }
    return message
  },
})

// 会社CD一意チェック
extend('companyCdUnique', {
  validate: async (value) => {
    try {
      await API.get(`/master/companies/${value}`)
      return i18n.t('MSG0006')
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return true
      } else {
        return i18n.t('MSG0002', { p0: i18n.t('ELE0002') })
      }
    }
  },
})

// 不良グループ一意チェック
extend('defectGroupCdUnique', {
  validate: async (value) => {
    try {
      await API.get(`/master/defectGroups/${value}`)
      return i18n.t('MSG0006')
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return true
      } else {
        return i18n.t('MSG0002', { p0: i18n.t('ELE0008') })
      }
    }
  },
})

// 不良CD一意チェック
extend('defectCdUnique', {
  validate: async (value) => {
    try {
      await API.get(`/master/defects/${value}`)
      return i18n.t('MSG0006')
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return true
      } else {
        return i18n.t('MSG0002', { p0: i18n.t('ELE0012') })
      }
    }
  },
})

// 検査装置CD一意チェック
extend('measInstCdUnique', {
  validate: async (value) => {
    try {
      await API.get(`/master/measInsts/${value}`)
      return i18n.t('MSG0006')
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return true
      } else {
        return i18n.t('MSG0002', { p0: i18n.t('ELE0026') })
      }
    }
  },
})

// 検査装置CD存在チェック
extend('measInstCdExists', {
  validate: async (value) => {
    try {
      await API.get(`/master/measInsts/${value}`)
      return true
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return i18n.t('MSG0010', { p0: value })
      } else {
        return i18n.t('MSG0002', { p0: i18n.t('ELE0026') })
      }
    }
  },
})

// ユーザーID一意チェック
extend('userCdUnique', {
  validate: async (value) => {
    try {
      await API.get(`/master/users/${value}`)
      return i18n.t('MSG0006')
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return true
      } else {
        return i18n.t('MSG0002', { p0: i18n.t('ELE0058') })
      }
    }
  },
})

// メール一意チェック
extend('mailUnique', {
  validate: async (value, { userCd }) => {
    try {
      const body = {
        mail: value,
        userCd: userCd,
      }
      const user = await API.post('/master/users/mail', body)
      if (user['userCd'] === userCd) {
        return true
      }
      return i18n.t('MSG0006')
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return true
      } else {
        return i18n.t('MSG0002', { p0: i18n.t('ELE0074') })
      }
    }
  },
  params: ['userCd'],
})

// 部品CD一意チェック
extend('partCdUnique', {
  validate: async (value) => {
    try {
      await API.get(`/master/partCds/${value}`)
      return i18n.t('MSG0006')
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return true
      } else {
        return i18n.t('MSG0002', { p0: i18n.t('ELE0059') })
      }
    }
  },
})

extend('checkMoldUnique', {
  validate: async (value, { ptCd }) => {
    try {
      const body = {
        partCd: ptCd,
        moldNo: value,
      }
      await API.get(`/master/parts/checkMoldUnique`, body)
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return true
      } else {
        return i18n.t('MSG0006')
      }
    }
  },
  params: ['ptCd'],
})

// XRFグループCD 一意チェック
extend('xrfGroupCdUnique', {
  validate: async (value) => {
    try {
      await API.get(`/master/xrfGroups/${value}`)
      return i18n.t('MSG0006')
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return true
      } else {
        return i18n.t('MSG0002', { p0: i18n.t('ELE0519') })
      }
    }
  },
})

// 半角英数字チェック
extend('alphaNum', {
  validate: (value) => {
    if (value.match(/^[a-zA-Z0-9]*$/)) {
      return true
    } else {
      return i18n.t('MSG0059', { p0: '{_field_}' })
    }
  },
})

// 半角文字チェック
extend('halfWidth', {
  validate: (value) => {
    return StringUtils.isHalfWidth(value)
  },
  message: (fieldName) => {
    let message = ''
    if (fieldName == '{field}') {
      // チェック項目のlabelが空文字の場合
      message = i18n.t('MSG0102')
    } else {
      message = i18n.t('MSG0020', { p0: fieldName })
    }
    return message
  },
})

// 自然数チェック
extend('naturalNumberQty', {
  validate: (value) => {
    if (value === '') {
      return true
    } else {
      if (value.toString().match(/^[0-9]*$/)) {
        if (1 <= value && value <= 9999999) {
          return true
        } else {
          return i18n.t('MSG0026', { p0: '{_field_}', p1: '1', p2: '9999999' })
        }
      } else {
        return i18n.t('MSG0021', { p0: '{_field_}' })
      }
    }
  },
})

// 整数範囲チェック (負の数はNG)
extend('rangeNumber', {
  validate: (value, { min, max }) => {
    if (value === '') {
      return true
    } else {
      if (value.toString().match(/^[0-9]*$/)) {
        if (Number(min) <= Number(value) && Number(value) <= Number(max)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  params: ['min', 'max'],
  message: (fieldName, placeholders) => {
    let message = ''
    if (fieldName == '{field}') {
      // チェック項目のlabelが空文字の場合
      message = i18n.t('MSG0071', { p0: placeholders.min, p1: placeholders.max })
    } else {
      message = i18n.t('MSG0026', { p0: fieldName, p1: placeholders.min, p2: placeholders.max })
    }
    return message
  },
})

// 規格値チェック
extend('inspCharacVal', {
  validate: (value) => {
    if (value === '') {
      return true
    } else {
      if (String(value).match(/^[+-]?[0-9]{1,5}(\.[0-9]{1,5})?$/)) {
        return true
      } else {
        return false
      }
    }
  },
  message: (fieldName) => {
    let message = ''
    if (fieldName == '{field}') {
      // チェック項目のlabelが空文字の場合
      message = i18n.t('MSG0071', { p0: '-99999.99999', p1: '99999.99999' })
    } else {
      message = i18n.t('MSG0026', { p0: fieldName, p1: '-99999.99999', p2: '99999.99999' })
    }
    return message
  },
})

extend('minValueZero', {
  validate: (value) => {
    if (value < 0) {
      return i18n.t('MSG0061', { p0: '{_field_}' })
    }
    return true
  },
})

// LotNo体系
extend('lotNoFormat', {
  validate: (value, regex) => {
    if (!regex || value.match(new RegExp(regex))) {
      return true
    } else {
      return i18n.t('MSG0125')
    }
  },
})

extend('maxFileSize', {
  validate: (file, maxSize) => {
    const fileSizeInMB = `${maxSize / 1024 / 1024} MB`
    if (file && file.size <= maxSize) {
      return true
    } else {
      return i18n.t('MSG0175', { p0: fileSizeInMB })
    }
  },
})
